import generate from 'jquery-plugin-generator';
$ = jQuery;


class ContentMenu {
	constructor($element, options){
		this.options = $.extend({menuOrderClass:"d-none"}, options);
		this.$element = $element;
		this.menu =  [];
		this.menuComputed = [];
		setTimeout(()=>this.build(), 1000);
	}

	getActiveSections(){
		function _getActiveSection(level){	
		let currentActive = null;
		let lastY = -100000000;
		$('.menu-level-'+level).each(function(){
			let bbox = this.getBoundingClientRect();
			if (bbox.y <=100 && bbox.y>lastY){
				lastY = bbox.y;
				currentActive = this;
			}
		});
		return currentActive;
		}
		return [
			_getActiveSection(1),
			_getActiveSection(2),
			_getActiveSection(3),

		].filter(x=>x);
	}



	updateActiveMenu(){
		this.$element.find('li, a').removeClass('active');
		const actives = this.getActiveSections();
		
		var items = this.menu.filter(x=>actives.find(el=>el===x.$sel[0]));
		items.map(x=>{
			$('.'+x.className, this.$element).addClass('active');
		});
	}

	get(){
		return this;
	}

	build(){
		const getLevel = ($el)=>{
			var level  = 0;
			if ($el.hasClass('menu-level-1')){
				level = 1;
				return level;
			}
			if ($el.hasClass('menu-level-2')){
				level = 2;
				return level;
			}
			if ($el.hasClass('menu-level-3')){
				level = 3;
				return level;
			}

			return level;
		}
		this.levelMin = 3;
		var CM = this;
		
		var id = 0;
		$('.entry-content').find('.menu-level-1, .menu-level-2, .menu-level-3').each(function(){
			var text = $(this).text();
			id++;

			if ($(this).hasClass('component') || $(this).data('shortcodeTag')){
				var _text = $(this).find('figcaption, .caption, .figcaption');
				if (!_text.length) _text = $(this).next('figcaption, .caption, .figcaption');
				if (_text.length){
					text = _text.text();
				} 
				else text = "#"+$(this).attr('id');
			}

			
			var level = getLevel($(this));
			if (level > 0){

				CM.levelMin = Math.min(level, CM.levelMin);
				CM.menu.push({
					label:text, 
					level:level, 
					className:'menu-'+id, 
					$sel:$(this), 
					children:[]}
					);
			}
		});
		for (var i=0; i<this.menu.length; i++){
			this.menu[i].level = this.menu[i].level - this.levelMin;
		}
		var M = {children:[], level:-1};
		var currentLevel1 = null;
		var currentLevel2 = null;
		for (var i=0; i<this.menu.length; i++){
			var item = this.menu[i];
			if (item.level==0){
				currentLevel1 = item;
				currentLevel2 = null;
				M.children[M.children.length] = item;
			}
			if (item.level == 1 && currentLevel1){
				currentLevel2 = item;
				currentLevel1.children[currentLevel1.children.length] = item;
			}
			if (item.level == 2 && currentLevel2){
				currentLevel2.children[currentLevel2.children.length] = item;
			}

		}
		this.menuComputed = M;
		this.display();
		$('.content-menu').on('click', '[level]', function(){
			var target = CM.getMenuTarget($(this).attr('level'));
			var $target = target.$sel;
			var top = $target.offset().top;
			if ($target[0].tagName.toLowerCase() != 'div'){
				top = top -60;
			}
			var  body = $("html, body");
			body.stop().animate({scrollTop:top}, 1000, 'swing');
		});
		$('.content-menu-toggler').click(function(){
			$('.content-menu').toggleClass('closed');
			var iclose = 'icon-close';
			var iopen = 'icon-post-menu';
			var icon = !$('.content-menu').hasClass('closed')?iclose:iopen;
			//$(this).removeClass(iclose).removeClass(iopen).addClass(icon);
		});
		$('[class*="menu-mirror-"]').css('cursor', 'pointer').click(function(){
			var A = this.className.match(/menu-mirror-\d+/);

			var menuID = A[0][A[0].length-1];
			$('.content-menu ul.level--1 > li:nth-child('+menuID+') > a').click();

		});

	}
	display($el){
		if ($('.content-menu').length ==0){
			alert('calling content menu without any menu container');
			return;
		}
		else {
			this.$element.html('<span class="content-menu-toggler icon-post-menu"></span><div class="content-menu-menu"></div>');
		}
		if (this.menu.length == 0){
			return;
		}
		var html = '<span class="content-menu-toggler icon-close"></span>'+this.displayNode(this.menuComputed);
		$('.content-menu-menu' , this.$element).html(html);

	}
	displayNode(node,levelprefix=""){
		var html ='';
		var levelprefix;
		if (node.level != -1)
			html += '<a level="'+levelprefix+'" class="level-'+node.level+' '+node.className+'"><span class="menu-order '+this.options.menuOrderClass+'">'+levelprefix+'</span> <span class="menu-label">'+node.label+'</span></a>';
		if (node.children.length){
			html += '<ul class="navbar-nav level-'+node.level+'">';
			for (var i=0; i<node.children.length; i++ ){
				let _levelprefix = levelprefix+(i+1)+'.';
				html += '<li>'+this.displayNode(node.children[i], _levelprefix)+'</li>';
			}
			html += '</ul>';
		}
		return html;
	}

	getMenuTarget(order){
		var _o = order.substr(0,order.length-1).split('.');

		function returnSub(el,indexArray){
			if (indexArray.length == 0) return null;
			var ind = parseInt(indexArray[0])-1;
			if (indexArray.length == 1) return el.children[ind];
			var _indexArray = indexArray.slice(1);
			return returnSub(el.children[ind], _indexArray)
		};

		return returnSub(this.menuComputed,_o);
	}

	
}



$.fn.contentMenu = generate(ContentMenu, {});
$(document).ready(function(){
	$('.content-menu').contentMenu();
});
$(window).scroll(function(){
	$('.content-menu').contentMenu('updateActiveMenu');
})